import { Signal, effect, untracked } from '@angular/core'

/**
 * Run `fn(next, previous)` when `source` changes — never on the value it already had.
 *
 * Three effects in this module hand-rolled this, each as a `let seen…` beside an effect whose first
 * statement existed only to register a dependency. A bare expression statement for its tracking
 * side effect reads as a mistake, and is one `@typescript-eslint/no-unused-expressions` away from
 * being reported as one. The body runs untracked, so what it reads afterwards does not become a
 * dependency of the next run.
 *
 * Must be called in an injection context, as `effect` must.
 */
export function onChange<T>(source: Signal<T>, fn: (next: T, previous: T) => void): void {
  let previous = untracked(source)

  effect(() => {
    const next = source()

    untracked(() => {
      if (next !== previous) {
        const was = previous

        previous = next
        fn(next, was)
      }
    })
  })
}
